<template>
  <section class="statusbar">
    <div class="logged-in-user">
      <span>{{user.firstName}} {{user.lastName}}</span>
    </div>
  </section>
</template>

<script>

export default {
  name: 'StatusbarPassword',
  props: ['user'],
  setup() {
    
  },
}
</script>



<style scoped>
.statusbar {
  background: #ddd;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logged-in-user{
  
  font-size: 14px;
  font-weight: bold;
 

}

</style>